
export default {
  props: {
    blogs: {
      type: Array,
      required: true,
    },
  },
}
